module.exports = __webpack_public_path__ + "img/before_after_flexsale_1.4c9edc60.png";